import { render, staticRenderFns } from "./BtnVoltarPasso.vue?vue&type=template&id=99dbcb14&"
import script from "./BtnVoltarPasso.vue?vue&type=script&lang=js&"
export * from "./BtnVoltarPasso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports